export const UPLOADING_SURVEY = 'Uploading Survey';
